import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "mainbox" }
const _hoisted_6 = { class: "list clearfix" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "messagelist" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { style: {"text-align":"center","margin-top":"0.2rem"} }
const _hoisted_11 = { class: "lett clearfix" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["poster", "src"]
const _hoisted_14 = ["src"]

import { reactive, onMounted, watch, ref } from "vue";
import Nav from "@/components/nav/Index.vue";
import type { ElScrollbar } from "element-plus";

import { useRouter, useRoute } from "vue-router";
import { getAllAttr, getAllMessage, getEnum } from "@/api/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const scrollbarRef: any = ref<InstanceType<typeof ElScrollbar>>();
const innerRef: any = ref(0);
const props = __props;

const mb: any = ref("");
watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);
const router = useRouter();
const route = useRoute();
const datas: any = reactive({
  dialogVisible: false,
  dialogVisible2: false,
  imgurl: "",
  scroll: 0,
  banner: "",
  filurl: localStorage.getItem("fileUrel"),
  max: "",
  messageType: "",
  index: 0,
  items: [],
  messages: {
    audeo: "",
    letter: "",
  },
});
const getData = () => {
  getAllAttr().then((res: any) => {
    for (const item in res.data) {
      for (const i of res.data[item]) {
        if (i.fileName) i.fileUrl = localStorage.getItem("fileUrel") + i.fileName;
      }
    }
    datas.items = res.data;
  });
};

const getMessage = () => {
  getAllMessage().then((res: any) => {
    datas.messages.audeo = res.data["MESSAGE_VIDEO"];
    if (res.data["MESSAGE_AUDIO"]) {
      datas.messages.audeo.push(...res.data["MESSAGE_AUDIO"]);
    }
    datas.messages.letter = res.data["MESSAGE_LETTER"];

    for (const item of datas.messages.audeo) {
      item.type = datas.messageType[item.contentType]?.enumName;
      if (item.content) item.content = localStorage.getItem("fileUrel") + item.content;
      if (item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
      if (item.orgLogoName)
        item.orgLogoName = localStorage.getItem("fileUrel") + item.orgLogoName;
    }
    for (const item of datas.messages.letter) {
      item.type = datas.messageType[item.contentType]?.enumName;
      if (item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
      if (item.orgLogoName)
        item.orgLogoName = localStorage.getItem("fileUrel") + item.orgLogoName;
    }
  });
};

const getEnumType = () => {
  datas.messageType = {};
  getEnum("MESSAGE").then((res: any) => {
    for (const item of res.data) {
      datas.messageType[item.enumKey] = item;
    }
  });
};

const checked = (i: any) => {
  datas.index = i;
};

const getBanner = (banner: any) => {
  datas.banner = banner;
};

const open = () => {
  datas.dialogVisible = true;
};

const addScroll = () => {
  if (datas.scroll < datas.max) datas.scroll += 300;
  scrollbarRef.value.setScrollLeft(datas.scroll);
};

const reduScroll = () => {
  if (datas.scroll > 0) datas.scroll -= 300;
  scrollbarRef.value.setScrollLeft(datas.scroll);
};

const click = (item: any) => {
  if (item.content) {
    datas.imgurl = item.content;
    datas.dialogVisible2 = true;
  }
};

onMounted(() => {
  getEnumType();
  getData();
  getMessage();
  mb.value = props.isMobile;
  setTimeout(() => {
    datas.max = innerRef.value.scrollWidth - innerRef.value.clientWidth;
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value ? 'Mobile' : 'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        style: 'ww',
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl + datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (v, k) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "items",
          key: k
        }, [
          _createElementVNode("h2", null, _toDisplayString(k), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index,
                style: _normalizeStyle({
              background: `url(${item.fileUrl})  no-repeat `,
              backgroundSize: 'cover',
            })
              }, [
                _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line" }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(item.description), 1)
              ], 4))
            }), 128))
          ])
        ]))
      }), 128)),
      _cache[8] || (_cache[8] = _createElementVNode("h2", null, "客户评价", -1)),
      _createElementVNode("div", {
        class: "cover",
        onClick: open
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"position":"absolute","width":"100%","height":"100%","background":"rgba(0,0,0,0.38)"} }, [
          _createElementVNode("div", { class: "btn" }, [
            _createElementVNode("i", { class: "iconfont icon-24gf-playCircle" })
          ])
        ], -1)),
        _createElementVNode("img", {
          style: {"height":"100%"},
          src: datas.messages.audeo[datas.index]?.fileurl
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (datas.max)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn",
              onClick: reduScroll
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "iconfont icon-zuo" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          style: {"display":"flex","justify-content":"center","flex-wrap":"wrap"},
          class: "cont",
          ref_key: "innerRef",
          ref: innerRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.messages.audeo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", { checked: index == datas.index }]),
              key: index,
              onClick: ($event: any) => (checked(index))
            }, [
              _createVNode(_component_el_image, {
                src: item.orgLogoName,
                fit: "fill"
              }, {
                error: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "icon-tupian iconfont" }, null, -1)
                ]))]),
                _: 1
              }, 8, ["src"]),
              _createElementVNode("h4", _hoisted_10, _toDisplayString(item.title), 1)
            ], 10, _hoisted_9))
          }), 128))
        ], 512),
        (datas.max)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "btn",
              onClick: addScroll,
              style: {"text-align":"right"}
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "iconfont icon-you" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.messages.letter, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card",
            key: index,
            style: _normalizeStyle({ background: `url(${item.fileurl}) 100%`, backgroundSize: 'cover' }),
            onClick: ($event: any) => (click(item))
          }, [
            _createElementVNode("h3", null, _toDisplayString(item.type), 1),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(item.title), 1)
          ], 12, _hoisted_12))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      "destroy-on-close": true,
      modelValue: datas.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.dialogVisible) = $event)),
      width: "50%",
      "custom-class": "dd"
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          ref: "videoPlayer",
          autoplay: "",
          controls: "",
          poster: datas.filurl + datas.messages.audeo[datas.index]?.fileName,
          src: datas.messages.audeo[datas.index]?.content,
          style: {"width":"100%","object-fit":"fill"}
        }, null, 8, _hoisted_13)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: datas.dialogVisible2,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.dialogVisible2) = $event)),
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: datas.filurl + datas.imgurl,
          alt: ""
        }, null, 8, _hoisted_14)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})